export default "__VITE_ASSET__XlOL$43f__"